import React from "react";
import { useSelector } from "react-redux";

import { Divider, Tabs, Typography } from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

import ProfileDetails from "js/pages/Profile/ProfileDetails";
import ReferralInvitations from "js/pages/Profile/Referrals/ReferralInvitations";

const { Title } = Typography;

const Profile = () => {
  const screen = useBreakpoint();
  const { userData } = useSelector((state) => state.entities.user);

  const itemTabs = [
    {
      label: "Perfil",
      key: "1",
      children: (
        <>
          <ProfileDetails />
        </>
      ),
    },
    {
      label: "Referidos",
      key: "2",
      children: (
        <>
          <ReferralInvitations />
        </>
      ),
      disabled: !userData?.is_validated,
    },
  ];

  return (
    <div id="profile">
      <div>
        <Title level={3}>Perfil</Title>
      </div>
      <Divider />
      <div style={{ marginTop: 30 }}>
        <Tabs
          defaultActiveKey="1"
          tabPosition={screen.lg ? "left" : "top"}
          items={itemTabs}
        />
      </div>
    </div>
  );
};

export default Profile;
